import { IPlanSummaryResponse } from '@containers/individualPortal/planSummary/planSummary.types';
import { PLAN_SUMMARY_ACTION_TYPES } from '@constants/actionTypes/planSummaryActionTypes';

type PlanSummaryType = {
    planSummaryData: IPlanSummaryResponse;
    isDataLoading: boolean;
    isDataError: boolean;
}

// Initial state typed to match the Account Activity events interface
export const INITIAL_STATE: PlanSummaryType = {
    planSummaryData: {} as IPlanSummaryResponse,
    isDataLoading: false,
    isDataError: false,
};

interface PlanSummaryAction {
    type: string;
    payload?: any;
}

// Reducer function with typed state and action
export default (state = INITIAL_STATE, action: PlanSummaryAction) => {
    switch (action?.type) {
        case PLAN_SUMMARY_ACTION_TYPES.SET_PLAN_DATA: {
            return {
                ...state,
                planSummaryData: action.payload.planSummaryData as IPlanSummaryResponse,
            };
        }
        case PLAN_SUMMARY_ACTION_TYPES.SET_DATA_LOADING: {
            return {
                ...state,
                isDataLoading: action.payload,
            };
        }
        case PLAN_SUMMARY_ACTION_TYPES.SET_DATA_ERROR: {
            return {
                ...state,
                isDataError: action.payload,
            };
        }
        default:
            return state;
    }
};
